import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3t2zevr8: FaireBrandEntity = {
  token: "b_3t2zevr8",
  type: "brand",
  name: "ZAQ Skin + Body Care",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c7b104e07f1b9a945b8f5f51dd3a1de8c4fe01c8fa6fabc2fa635c317a481dd4/1555619176.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2b88fe611e1918252774893080cec7f65f6a1e9210cf2ff90b6bfa53df1d4ba7.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c7b104e07f1b9a945b8f5f51dd3a1de8c4fe01c8fa6fabc2fa635c317a481dd4/1555619176.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2b88fe611e1918252774893080cec7f65f6a1e9210cf2ff90b6bfa53df1d4ba7.jpeg",
  location: "Niles, IL, USA",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 61,
  isInsider: true,
  description:
    "ZAQ was launched in 2011 and is an award winning industry leader for skincare and cosmetic treatments. We provide high quality and high-tech products and devices which are currently being used by consumers and licensed estheticians at spas across North America and Europe. Our customers love how easy to use our products are and enjoy simplifying their lives while taking us with them on their travels. \n\nZAQ Collection:\n\nElectronic and non-electric facial cleansing devices, skin tightening devices, blackhead removers, Gua Sha stones, LED facial masks, collagen masks, massaging tools, Aeromatic therapy diffusers, essential oils, body oils, lotions, skin serums, cleansers, CBD pain & relief creams and much more!\n\n\n\n\nWhen it comes to skin and body care, we've got you covered for daily facial cleansing rituals and rejuvenation needs.\n\nwww.ZAQ.com",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:16.838Z",
    importedBy: "entity-db-cli",
  },
};
